import name from './name'
import api from './api'
import reducer from './reducers'

export default { name, api, reducer }
